import { observer } from 'mobx-react';

import { useStores } from '@/hooks/use-stores';

import HelixConnectivityIcon from '../HelixConnectivityIcon/HelixConnectivityIcon';
import { ControlIcon } from '../ControlIcon/ControlIcon';

const ConnectivityIcon = observer(props => {
  const { stationStore } = useStores();

  const currentTier = stationStore?.stationTier;

  return currentTier < 2 ? <HelixConnectivityIcon {...props} /> : <ControlIcon {...props} />;
});

export default ConnectivityIcon;
